import PropTypes from 'prop-types';
import { TextField } from '@mui/material';

import {
	SALESFORCE_TASK_MAX_COMMENTS_LENGTH,
	isSalesforceTaskCommentsTooLong,
} from './salesforceTaskValidation';

const SalesforceTaskCommentsField = ({
	value,
	onChange,
	disabled = false,
	inputRef,
	autoFocus = false,
	minRows = 4,
	maxRows = 8,
	placeholder = 'Add task comments...',
}) => {
	const commentsLength = value.trim().length;
	const isTooLong = isSalesforceTaskCommentsTooLong(value);

	return (
		<TextField
			inputRef={inputRef}
			autoFocus={autoFocus}
			fullWidth
			multiline
			minRows={minRows}
			maxRows={maxRows}
			value={value}
			onChange={onChange}
			disabled={disabled}
			error={isTooLong}
			placeholder={placeholder}
			helperText={
				isTooLong
					? `Comments cannot exceed ${SALESFORCE_TASK_MAX_COMMENTS_LENGTH.toLocaleString()} characters`
					: `${commentsLength.toLocaleString()} / ${SALESFORCE_TASK_MAX_COMMENTS_LENGTH.toLocaleString()}`
			}
			slotProps={{
				htmlInput: {
					maxLength: SALESFORCE_TASK_MAX_COMMENTS_LENGTH + 1,
					'data-testid': 'task-comments-input',
				},
			}}
			sx={{
				'& .MuiInputBase-root': {
					alignItems: 'flex-start',
					fontSize: '12px',
					borderRadius: '6px',
					backgroundColor: 'background.paper',
				},
				'& textarea': {
					fontSize: '12px',
					maxHeight: 300,
					overflowY: 'auto',
				},
				'& .MuiFormHelperText-root': {
					fontSize: '10px',
					marginLeft: 0,
				},
			}}
		/>
	);
};

SalesforceTaskCommentsField.propTypes = {
	value: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	disabled: PropTypes.bool,
	inputRef: PropTypes.object,
	autoFocus: PropTypes.bool,
	minRows: PropTypes.number,
	maxRows: PropTypes.number,
	placeholder: PropTypes.string,
};

export default SalesforceTaskCommentsField;
